<script setup lang="ts">
defineProps<{
    icon?: string;
}>();

const emit = defineEmits<(e: "click", event: MouseEvent) => void>();
</script>

<template>
    <div class="LinkLike">
        <icon v-if="icon" :icon="icon" />
        <div class="inner-text" @click="emit('click', $event)">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.LinkLike {
    color: $grey;
    display: flex;
    align-items: center;
    transition: 0.2s linear;

    .Icon {
        margin-right: calc($padding / 3);

        &,
        svg {
            height: 16px;
            width: 16px;
        }
        svg {
            fill: $grey;
        }
    }
    .inner-text {
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
